import useSWR from "swr";
import { usePlace } from "../providers/PlaceProvider";
import { HTTPClient } from "../HTTPClient";

/**
 * /reviews/config for the selected place, fetched once per load.
 *
 * ToDoProvider, useDashboardData and ReviewsManagementView all need this
 * payload. They used to GET it separately: the providers sit outside the route
 * Suspense boundary and the views inside it, so the requests do not reliably
 * overlap and the in-flight sharing in HTTPClient cannot collapse them. One SWR
 * key makes the mount order irrelevant.
 *
 * `loaded` distinguishes "still fetching" from "fetched, and there is nothing" —
 * the to-do list shows a spinner on the first and a cross on the second.
 */
export function useReviewsConfig() {
  const { selectedPlace } = usePlace();

  const { data, isLoading, mutate } = useSWR(
    selectedPlace?.id ? ["reviews-config", selectedPlace.id] : null,
    () =>
      HTTPClient.get("/reviews/config?id=" + selectedPlace!.id)
        .then(({ data: config }) => config)
        .catch(() => null),
    { revalidateIfStale: false, revalidateOnFocus: false, revalidateOnReconnect: false }
  );

  return { config: data ?? null, loaded: !!selectedPlace?.id && !isLoading, refresh: mutate };
}
